import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { retryStrategy } from '@personal-area/global/http/services';
import { UserFacade } from '@personal-area/global/users/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  catchError,
  filter,
  map,
  of,
  retryWhen,
  switchMap,
  withLatestFrom,
} from 'rxjs';

import { IdentityVerificationApiService } from '../../services/identity-verification-api.service';
import * as identityActions from '../actions/identity';

@Injectable()
export class IdentityVerificationEffects {
  constructor(
    private _actions$: Actions,
    private _identityVerificationService: IdentityVerificationApiService,
    private _userFacade: UserFacade,
  ) {}

  public getIdentityFlow$ = createEffect(() =>
    this._actions$.pipe(
      ofType(identityActions.GetIdentityFlow),
      switchMap(() => this._userId$),
      switchMap((userId) =>
        this._identityVerificationService
          .initializeIdentityVerification(userId)
          .pipe(
            map((settings) =>
              identityActions.GetIdentityFlowSuccess({ settings }),
            ),
            retryWhen(retryStrategy()),
            catchError(() => of(identityActions.GetIdentityFlowFail())),
          ),
      ),
    ),
  );

  public getRequest$ = createEffect(() =>
    this._actions$.pipe(
      ofType(identityActions.GetRequest),
      switchMap(() => this._userId$),
      switchMap((userId) =>
        this._identityVerificationService.checkRequest(userId).pipe(
          map(({ reason }) =>
            identityActions.GetRequestSuccess({ rejectReason: reason || '' })
          ),
          retryWhen(retryStrategy()),
          catchError((error: HttpErrorResponse) =>
            error.status === 404
              ? of(identityActions.GetRequestSuccess({ rejectReason: '' }))
              : of(identityActions.GetRequestFail()),
          ),
        ),
      ),
    ),
  );

  private _userId$ = this._userFacade.isUserLoaded$.pipe(
    filter(Boolean),
    withLatestFrom(this._userFacade.user$, (_, { id }) => id),
  );
}
